import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Platform } from '@ionic/angular';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';

@Injectable({
  providedIn: 'root'
})
export class CordovaTranslateLoader implements TranslateLoader {
  constructor(
    private platform: Platform,
    private http: HTTP
  ) {}

  getTranslation(lang: string): Observable<any> {
    return from(this.loadTranslationFile(lang)).pipe(
      map(response => {
        console.log(`CordovaTranslateLoader: Successfully loaded translation for ${lang}`);
        return response;
      }),
      catchError(error => {
        console.error(`CordovaTranslateLoader: Error loading translation for ${lang}:`, error);
        // Return empty object as fallback
        return from(Promise.resolve({}));
      })
    );
  }

  private async loadTranslationFile(lang: string): Promise<any> {
    const fileName = `${lang}.json`;
    
    // Wait for platform to be ready
    await this.platform.ready();
    
    try {
      // Try to load from assets using Cordova HTTP plugin
      const response = await this.http.get(`assets/i18n/${fileName}`, {}, {});
      
      if (response && response.data) {
        console.log(`CordovaTranslateLoader: Loaded ${fileName} using Cordova HTTP`);
        const raw = response.data;
        if (typeof raw === 'string') {
          try {
            return JSON.parse(raw) as Record<string, unknown>;
          } catch {
            console.error(`CordovaTranslateLoader: ${fileName} was not valid JSON`);
            throw new Error('Invalid JSON in translation response');
          }
        }
        return raw;
      } else {
        throw new Error('No data received from HTTP request');
      }
    } catch (cordovaError) {
      console.warn(`CordovaTranslateLoader: Cordova HTTP failed for ${fileName}, trying fetch:`, cordovaError);
      
      // Fallback to fetch API
      try {
        const response = await fetch(`assets/i18n/${fileName}`);
        if (response.ok) {
          const data = await response.json();
          console.log(`CordovaTranslateLoader: Loaded ${fileName} using fetch API`);
          return data;
        } else {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
      } catch (fetchError) {
        console.error(`CordovaTranslateLoader: Both Cordova HTTP and fetch failed for ${fileName}:`, fetchError);
        throw fetchError;
      }
    }
  }
} 